import { dcaVsLumpSumArticleTranslations } from './dcaVsLumpSumArticle';
import { howMuchToRetireArticleTranslations } from './howMuchToRetireArticle';
import { salaryNegotiationWorthArticleTranslations } from './salaryNegotiationWorthArticle';

export const resourcesTranslations = {
  en: {
    resources: {
      title: "Financial Resources",
      subtitle: "Educational content to help you make better financial decisions.",
      tabs: {
        articles: "Articles",
        videos: "Videos",
        calculators: "Calculators"
      },
      categories: {
        investment: "Investment",
        retirement: "Retirement",
        taxPlanning: "Tax Planning",
        budgeting: "Budgeting & Savings",
        mortgages: "Mortgages & Real Estate",
        debt: "Debt Management",
        technology: "Financial Technology",
        security: "Financial Security",
        economy: "Economy",
        career: "Career"
      },
      search: {
        placeholder: "Search resources...",
        noResults: "No results found",
        noResultsDescription: "Try different search terms",
        filterByCategory: "Filter by category",
        allCategories: "All categories",
        showingResults: "Showing {count} of {total} resources",
        clearFilters: "Clear filters"
      },
      loadMore: "Load More",
      showLess: "Show Less",
      article: {
        readMore: "Read Article",
        read: "Read Article"
      },
      videos: {
        comingSoon: "Video Content Coming Soon",
        inProgress: "Our team is working on creating educational videos.",
        video1: {
          title: "What is inflation?",
          description: "Economists constantly talk about inflation and tend to suggest it's something very bad. But why exactly, where does it come from and what can be done to control it?",
          category: "economy",
          duration: "8:00"
        }
      },
      article1: {
        title: "The Power of Compound Interest",
        description: "Learn how compound interest can exponentially grow your wealth over time with consistent investing."
      },
      article2: {
        title: "Retirement Planning Guide",
        description: "Essential strategies for planning your retirement and ensuring financial security in your golden years."
      },
      article3: {
        title: "Tax Optimization Strategies",
        description: "Advanced techniques to minimize your tax burden and maximize your investment returns."
      },
      article4: {
        title: "Building an Emergency Fund",
        description: "Learn how to build and maintain an emergency fund to protect yourself from financial uncertainty."
      },
      article5: {
        title: "Understanding Risk vs Return",
        description: "Learn about the fundamental relationship between investment risk and potential returns to make informed decisions."
      },
      article6: {
        title: "Common Investing Mistakes and How to Avoid Them",
        description: "Discover the most common investment pitfalls and learn strategies to avoid costly mistakes."
      },
      article7: {
        title: "Renting vs Buying: Pros and Cons Based on Your Situation",
        description: "Make the right housing decision for your financial future by understanding the advantages and disadvantages of each option."
      },
      article8: {
        title: "What is Inflation and How It Affects You",
        description: "Understanding the economic force that impacts your purchasing power and financial decisions."
      },
      article9: {
        title: "Cryptocurrencies: Trend or Long-Term Investment?",
        description: "A balanced analysis of digital currencies as an investment opportunity, covering risks and potential."
      },
      article10: {
        title: "Monthly Saving Challenges to Improve Your Personal Finances",
        description: "Transform your financial habits with engaging monthly challenges designed to boost your savings and build lasting money management skills."
      },
      article11: {
        title: "How to Avoid Impulse Buying",
        description: "Learn practical strategies to control spending urges and make more mindful financial decisions for a healthier financial future."
      },
      article12: {
        title: "How to Renegotiate Your Mortgage in 2025",
        description: "Complete guide with practical steps to renegotiate your mortgage and save on your monthly payments."
      },
      article13: {
        title: "Buy Now Pay Later (BNPL): Budget Impact and Smart Usage",
        description: "Learn how BNPL services affect your budget, their risks and benefits, and how to use them responsibly for better financial health."
      },
      article14: {
        title: "Use AI to optimize your personal finances: apps, risks and real cases",
        description: "Discover how artificial intelligence is revolutionizing personal money management and which tools can transform your financial situation."
      },
      article15: {
        title: "Practical Tax Guide for Cryptocurrencies: Declare Correctly and Avoid Penalties",
        description: "Everything you need to know about tax obligations with cryptocurrencies to comply with tax authorities."
      },
      article16: {
        title: "Investing with $100: 10 Real Strategies to Start Today",
        description: "Discover how to begin your journey towards financial freedom with a small but smart initial investment."
      },
      article17: {
        title: "ETFs and Index Funds: The Practical Recipe for a Crisis-Resistant Portfolio",
        description: "Build a solid and diversified investment strategy that withstands global financial market turbulence."
      },
      article18: {
        title: "Protect Your Money from Digital Scams: Vishing, Smishing, Deepfakes and What to Do",
        description: "Complete guide to identify and protect yourself from the most dangerous digital financial threats."
      },
      article19: {
        title: "Self-Employed Finances: How to Budget with Variable Income and Prepare for Retirement",
        description: "Practical strategies to manage your money as a freelancer, create financial stability, and build a prosperous future without depending on a fixed salary."
      },
      article20: {
        title: "Sustainable Investment Without Traps: How to Detect Greenwashing in ESG Funds",
        description: "Learn to identify truly sustainable funds and avoid falling for misleading marketing practices in the ESG investment world."
      },
      article21: {
        title: "Saving Against Inflation: Short and Medium-Term Tactics That Really Work",
        description: "Proven strategies to protect and grow your savings in inflationary environments through practical, risk-managed approaches."
      },
      article22: {
        title: "Negotiate a Better Salary: Arguments, Structure and Examples to Increase Your Income",
        description: "Discover the most effective strategies, techniques and arguments to get the salary increase you deserve."
      },
      article23: {
        title: "Taxation for Digital Nomads and Remote Workers: What You Need to Know When Moving",
        description: "Complete guide on tax obligations, tax residency and tax optimization for professionals working remotely internationally."
      },
      article24: {
        title: "Financial Independence: A Realistic Plan (No Fantasies)",
        description: "Practical and realistic strategies to achieve financial independence without empty promises or impossible schemes. A step-by-step approach based on solid fundamentals."
      },
      article25: {
        title: "Robo-advisors vs Human Advisors: How to Choose Based on Costs and Profile",
        description: "Complete comparison between automated and human financial advisory services. Learn to choose the best option according to your budget, needs and investor profile."
      },
      article26: {
        title: "Tips to Pay Less on Your Electricity, Gas and Internet Bills",
        description: "Practical and effective strategies to significantly reduce your household utility expenses. Discover proven methods to save 15-40% on your monthly bills."
      },
      article27: {
        title: "Simple Guide to Understanding Personal Income Tax and Paying Less Taxes",
        description: "Complete guide to personal income tax optimization. Learn legal strategies, deductions, and practical tips to reduce your tax burden and maximize your savings."
      },
      article28: {
        title: "How to Start Investing in the Stock Market with Little Money",
        description: "Complete guide to start investing in stocks with small amounts. Learn strategies, avoid mistakes, and build wealth step by step with minimal capital."
      },
      article29: {
        title: "Financial Planning Before Having Children",
        description: "Essential financial planning guide for couples planning to have children. Learn about budgeting, saving strategies, and long-term financial preparation for family growth."
      },
      article30: {
        title: "How to Save Money on a Low Salary",
        description: "Practical strategies to build a solid financial future regardless of your income size. Learn realistic and sustainable methods to save money on a tight budget."
      },
      article31: {
        title: "Why 90% of Traders Lose Money",
        description: "Discover the real reasons behind trading failure and learn how to avoid the most common mistakes that destroy capital. A realistic guide without fantasies."
      },
      article32: {
        title: "The Real Cost of Never Investing",
        description: "Discover the invisible price you pay every day by keeping your money idle and how it's silently affecting your financial future."
      },
      article33: {
        title: "Invisible Expenses Costing You $3,000 Per Year",
        description: "Discover the small hidden expenses draining your bank account without you noticing and how to recover that money."
      },
      article34: {
        title: "AI in Investments: How Algorithms are Changing the Way We Invest",
        description: "Explore how artificial intelligence and machine learning are transforming investment strategies with automated analysis and smarter decision-making."
      },
      article35: {
        title: "Lifestyle Inflation: Your Worst Financial Enemy",
        description: "Discover how gradual increases in your lifestyle can silently sabotage your wealth and learn proven strategies to combat it."
      },
      article36: {
        title: "Preparing Your Finances Before Becoming a Parent: Complete Guide",
        description: "Essential guide to prepare your finances before parenthood. Learn to build a solid financial foundation, manage debts, and plan your family future with practical strategies."
      },
      article37: {
        title: "DCA vs. Lump Sum Investing: What the Data Says",
        description: "Discover the smartest investment strategy based on historical evidence. Complete analysis of Dollar Cost Averaging vs Lump Sum with real data, psychological factors, and guidance for your decision."
      },
      article38: {
        title: "How Much You Really Need to Retire",
        description: "Beyond magic formulas: a practical guide to calculating your retirement number."
      },
      article39: {
        title: "Financial Education for Couples: How to Manage Money in a Relationship",
        description: "Learn to build a solid financial relationship with your partner. Practical strategies for communication, joint budgets and shared financial goals."
      },
      article40: {
        title: "Your First Salary: How to Invest It Wisely",
        description: "Discover essential strategies to manage your first salary intelligently and build a solid financial foundation from the start of your professional career."
      },
      article41: {
        title: "Automate Your Finances in One Afternoon",
        description: "Learn how to set up an automated financial system that works for you 24/7, allowing you to make better decisions without daily effort."
      },
      article42: {
        title: "The 1% Rule That Will Transform Your Finances",
        description: "Discover how small daily improvements of just 1% can radically transform your financial situation through the power of compound habits and marginal gains."
      },
      article43: {
        title: "The Hidden Power of Reinvesting Dividends",
        description: "Discover how dividend reinvestment can dramatically accelerate your wealth growth through compound returns and strategic portfolio building."
      },
      article44: {
        title: "Negotiating Your Salary Is Worth 100,000€",
        description: "Discover how a single salary negotiation can represent a six-figure difference over your career. The most profitable financial decision you'll make in your professional life."
      },
      article45: {
        title: "The Fear of Investing Costs You Dearly",
        description: "Discover the true cost of investment fear and learn practical strategies to overcome it with confidence and gradual action."
      },
      article46: {
        title: "Before Quitting Your Job, Do This",
        description: "The critical decisions you must make before resigning to protect your financial and professional future."
      },
    },
    ...dcaVsLumpSumArticleTranslations.en,
    ...howMuchToRetireArticleTranslations.en,
    ...salaryNegotiationWorthArticleTranslations.en
  },
  es: {
    resources: {
      title: "Recursos Financieros",
      subtitle: "Contenido educativo para ayudarte a tomar mejores decisiones financieras.",
      tabs: {
        articles: "Artículos",
        videos: "Videos",
        calculators: "Calculadoras"
      },
      categories: {
        investment: "Inversión",
        retirement: "Jubilación",
        taxPlanning: "Planificación Fiscal",
        budgeting: "Presupuesto y Ahorro",
        mortgages: "Hipotecas y Bienes Raíces",
        debt: "Gestión de Deudas",
        technology: "Tecnología Financiera",
        security: "Seguridad Financiera",
        economy: "Economía",
        career: "Carrera Profesional"
      },
      search: {
        placeholder: "Buscar recursos...",
        noResults: "No se encontraron resultados",
        noResultsDescription: "Intenta con otros términos de búsqueda",
        filterByCategory: "Filtrar por categoría",
        allCategories: "Todas las categorías",
        showingResults: "Mostrando {count} de {total} recursos",
        clearFilters: "Limpiar filtros"
      },
      loadMore: "Ver más",
      showLess: "Ver menos",
      article: {
        readMore: "Leer Artículo",
        read: "Leer Artículo"
      },
      videos: {
        comingSoon: "Contenido de Video Próximamente",
        inProgress: "Nuestro equipo está trabajando en crear videos educativos.",
        video1: {
          title: "¿Qué es la inflación?",
          description: "Los economistas hablan constantemente de la inflación y tienden a sugerir que es algo muy malo. Pero ¿por qué exactamente, de dónde proviene y qué se puede hacer para controlarla?",
          category: "Economía",
          duration: "8:00"
        }
      },
      article1: {
        title: "El Poder del Interés Compuesto",
        description: "Aprende cómo el interés compuesto puede hacer crecer exponencialmente tu riqueza con inversiones consistentes."
      },
      article2: {
        title: "Guía de Planificación de Jubilación",
        description: "Estrategias esenciales para planificar tu jubilación y asegurar la seguridad financiera en tus años dorados."
      },
      article3: {
        title: "Estrategias de Optimización Fiscal",
        description: "Técnicas avanzadas para minimizar tu carga fiscal y maximizar el retorno de tus inversiones."
      },
      article4: {
        title: "Construir un Fondo de Emergencia",
        description: "Aprende cómo construir y mantener un fondo de emergencia para protegerte de la incertidumbre financiera."
      },
      article5: {
        title: "Entendiendo Riesgo vs Rendimiento",
        description: "Aprende sobre la relación fundamental entre el riesgo de inversión y los rendimientos potenciales para tomar decisiones informadas."
      },
      article6: {
        title: "Errores Comunes de Inversión y Cómo Evitarlos",
        description: "Descubre los errores de inversión más comunes y aprende estrategias para evitar errores costosos."
      },
      article7: {
        title: "Alquilar vs Comprar: Ventajas y Desventajas Según Tu Situación",
        description: "Toma la decisión correcta de vivienda para tu futuro financiero entendiendo las ventajas y desventajas de cada opción."
      },
      article8: {
        title: "Qué es la Inflación y Cómo te Afecta",
        description: "Entendiendo la fuerza económica que impacta tu poder adquisitivo y decisiones financieras."
      },
      article9: {
        title: "Criptomonedas: ¿Tendencia o Inversión a Largo Plazo?",
        description: "Un análisis equilibrado de las monedas digitales como oportunidad de inversión, cubriendo riesgos y potencial."
      },
      article10: {
        title: "Desafíos de Ahorro Mensuales para Mejorar tus Finanzas Personales",
        description: "Transforma tus hábitos financieros con desafíos mensuales atractivos diseñados para aumentar tus ahorros y desarrollar habilidades duraderas de gestión del dinero."
      },
      article11: {
        title: "Cómo Evitar las Compras Impulsivas",
        description: "Aprende estrategias prácticas para controlar los impulsos de gasto y tomar decisiones financieras más conscientes para un futuro financiero más saludable."
      },
      article12: {
        title: "Cómo Renegociar tu Hipoteca en 2025",
        description: "Guía completa con pasos prácticos para renegociar tu hipoteca y ahorrar en tus pagos mensuales."
      },
      article13: {
        title: "Comprar Ahora y Pagar Después (BNPL): Impacto en tu Presupuesto",
        description: "Aprende cómo los servicios BNPL afectan tu presupuesto, sus riesgos y beneficios, y cómo usarlos responsablemente para mejor salud financiera."
      },
      article14: {
        title: "Usa la IA para optimizar tus finanzas personales: apps, riesgos y casos reales",
        description: "Descubre cómo la inteligencia artificial está revolucionando la gestión del dinero personal y qué herramientas pueden transformar tu situación financiera."
      },
      article15: {
        title: "Guía Fiscal Práctica para Criptomonedas: Declara Bien y Evita Sanciones",
        description: "Todo lo que necesitas saber sobre obligaciones fiscales con criptomonedas para cumplir con las autoridades tributarias."
      },
      article16: {
        title: "Invertir con 100 €: 10 estrategias reales para empezar hoy mismo",
        description: "Descubre cómo comenzar tu camino hacia la libertad financiera con una inversión inicial pequeña pero inteligente."
      },
      article17: {
        title: "ETFs y Fondos Indexados: La Receta Práctica para una Cartera Resistente a Crisis",
        description: "Construye una estrategia de inversión sólida y diversificada que resista las turbulencias del mercado financiero global."
      },
      article18: {
        title: "Protege tu dinero de estafas digitales: vishing, smishing, deepfakes y qué hacer",
        description: "Guía completa para identificar y protegerte de las amenazas financieras digitales más peligrosas."
      },
      article19: {
        title: "Finanzas para autónomos: cómo presupuestar con ingresos variables y preparar tu jubilación",
        description: "Estrategias prácticas para gestionar tu dinero como freelance, crear estabilidad financiera y construir un futuro próspero sin depender de un salario fijo."
      },
      article20: {
        title: "Inversión Sostenible sin Trampas: Cómo Detectar Greenwashing en Fondos ESG",
        description: "Aprende a identificar fondos verdaderamente sostenibles y evita caer en prácticas de marketing engañoso en el mundo de la inversión ESG."
      },
      article21: {
        title: "Ahorro ante la inflación: tácticas de corto y medio plazo que realmente funcionan",
        description: "Estrategias probadas para proteger y hacer crecer tus ahorros en entornos inflacionarios a través de enfoques prácticos y de riesgo gestionado."
      },
      article22: {
        title: "Negocia mejor tu salario: argumentos, estructura y ejemplos para subir ingresos",
        description: "Descubre las estrategias, técnicas y argumentos más efectivos para conseguir el aumento salarial que mereces."
      },
      article23: {
        title: "Fiscalidad para nómadas digitales y teletrabajadores: lo que debes saber al mudarte",
        description: "Guía completa sobre obligaciones fiscales, residencia fiscal y optimización tributaria para profesionales que trabajan de forma remota a nivel internacional."
      },
      article24: {
        title: "Independencia financiera: un plan realista (sin fantasías)",
        description: "Estrategias prácticas y realistas para alcanzar la independencia financiera sin promesas vacías ni esquemas imposibles. Un enfoque paso a paso basado en fundamentos sólidos."
      },
      article25: {
        title: "Roboadvisors vs asesores humanos: cómo elegir según costes y perfil",
        description: "Comparativa completa entre servicios de asesoramiento financiero automatizado y humano. Aprende a elegir la mejor opción según tu presupuesto, necesidades y perfil inversor."
      },
      article26: {
        title: "Trucos para Pagar Menos en tus Facturas de Luz, Gas e Internet",
        description: "Estrategias prácticas y efectivas para reducir significativamente tus gastos en servicios básicos del hogar. Descubre métodos probados para ahorrar entre 15-40% en tus facturas mensuales."
      },
      article27: {
        title: "Guía sencilla para entender el IRPF y pagar menos impuestos",
        description: "Guía completa para la optimización del IRPF. Aprende estrategias legales, deducciones y consejos prácticos para reducir tu carga fiscal y maximizar tus ahorros."
      },
      article28: {
        title: "Cómo empezar a invertir en bolsa con poco dinero",
        description: "Guía completa para empezar a invertir en bolsa con pequeñas cantidades. Aprende estrategias, evita errores y construye riqueza paso a paso con capital mínimo."
      },
      article29: {
        title: "Planifica tus finanzas antes de tener hijos",
        description: "Guía esencial de planificación financiera para parejas que planean tener hijos. Aprende sobre presupuestos, estrategias de ahorro y preparación financiera a largo plazo."
      },
      article30: {
        title: "Cómo ahorrar dinero cuando cobras un sueldo bajo",
        description: "Estrategias prácticas para construir un futuro financiero sólido sin importar el tamaño de tus ingresos. Aprende métodos realistas y sostenibles para ahorrar dinero con un presupuesto ajustado."
      },
      article31: {
        title: "Por qué el 90% de traders pierden dinero",
        description: "Descubre las razones reales detrás del fracaso en trading y aprende a evitar los errores más comunes que destruyen capital. Una guía realista sin fantasías."
      },
      article32: {
        title: "El Coste Real de No Invertir Nunca",
        description: "Descubre el precio invisible que pagas cada día al mantener tu dinero inactivo y cómo está afectando silenciosamente tu futuro financiero."
      },
      article33: {
        title: "Gastos Invisibles que te Cuestan 3.000€ al Año",
        description: "Descubre los pequeños gastos ocultos que están drenando tu cuenta bancaria sin que te des cuenta y cómo recuperar ese dinero."
      },
      article34: {
        title: "IA en Inversiones: Cómo los Algoritmos Están Cambiando la Forma de Invertir",
        description: "Explora cómo la inteligencia artificial y el machine learning están transformando las estrategias de inversión con análisis automatizado y toma de decisiones más inteligente."
      },
      article35: {
        title: "Lifestyle Inflation: Tu Peor Enemigo Financiero",
        description: "Descubre cómo el aumento gradual de tu estilo de vida puede sabotear tu patrimonio sin que te des cuenta y aprende a combatirlo."
      },
      article36: {
        title: "Preparar tus Finanzas Antes de Ser Padre: Guía Completa",
        description: "Guía esencial para preparar tus finanzas antes de la paternidad. Aprende a construir una base financiera sólida, gestionar deudas y planificar el futuro familiar con estrategias prácticas."
      },
      article37: {
        title: "DCA vs. Invertir Todo de Golpe: Qué Dicen los Datos",
        description: "Descubre la estrategia de inversión más inteligente basada en evidencia histórica. Análisis completo de Dollar Cost Averaging vs Lump Sum con datos reales, factores psicológicos y guía para tu decisión."
      },
      article38: {
        title: "Cuánto necesitas realmente para jubilarte",
        description: "Más allá de las fórmulas mágicas: una guía práctica para calcular tu número de retiro."
      },
      article39: {
        title: "Educación Financiera para Parejas: Cómo Gestionar el Dinero en Relación",
        description: "Aprende a construir una relación financiera sólida con tu pareja. Estrategias prácticas para comunicación, presupuestos conjuntos y metas financieras compartidas."
      },
      article40: {
        title: "Tu primer sueldo: cómo invertirlo bien",
        description: "Descubre las estrategias esenciales para gestionar tu primer salario de forma inteligente y construir una base financiera sólida desde el inicio de tu carrera profesional."
      },
      article41: {
        title: "Automatiza tus finanzas en una tarde",
        description: "Aprende a configurar un sistema financiero automatizado que trabaje para ti las 24 horas del día, permitiéndote tomar mejores decisiones sin esfuerzo diario."
      },
      article42: {
        title: "La Regla del 1% que Cambiará tu Economía",
        description: "Descubre cómo pequeñas mejoras diarias de solo el 1% pueden transformar radicalmente tu situación financiera a través del poder de los hábitos compuestos y las ganancias marginales."
      },
      article43: {
        title: "El Poder Oculto de Reinvertir Dividendos",
        description: "Descubre cómo la reinversión de dividendos puede acelerar dramáticamente el crecimiento de tu patrimonio a través de rendimientos compuestos y construcción estratégica de cartera."
      },
      article44: {
        title: "Negociar tu salario vale 100.000€",
        description: "Descubre cómo una sola negociación salarial puede representar una diferencia de seis cifras a lo largo de tu carrera. La decisión financiera más rentable que tomarás en tu vida profesional."
      },
      article45: {
        title: "El Miedo a Invertir Te Sale Muy Caro",
        description: "Descubre cuánto te cuesta realmente el miedo a dar el primer paso en inversión y aprende estrategias prácticas para superarlo con confianza y acción gradual."
      },
      article46: {
        title: "Antes de dejar tu trabajo, haz esto",
        description: "Las decisiones críticas que debes tomar antes de renunciar para proteger tu futuro financiero y profesional."
      }
    },
    ...dcaVsLumpSumArticleTranslations.es,
    ...howMuchToRetireArticleTranslations.es,
    ...salaryNegotiationWorthArticleTranslations.es
  },
  de: {
    resources: {
      title: "Finanzressourcen",
      subtitle: "Bildungsinhalte, die Ihnen helfen, bessere finanzielle Entscheidungen zu treffen.",
      tabs: {
        articles: "Artikel",
        videos: "Videos",
        calculators: "Rechner"
      },
      categories: {
        investment: "Investition",
        retirement: "Rente",
        taxPlanning: "Steuerplanung",
        budgeting: "Budgetierung & Sparen",
        mortgages: "Hypotheken & Immobilien",
        debt: "Schuldenverwaltung",
        technology: "Finanztechnologie",
        security: "Finanzsicherheit",
        economy: "Wirtschaft",
        career: "Berufslaufbahn"
      },
      search: {
        placeholder: "Ressourcen suchen...",
        noResults: "Keine Ergebnisse gefunden",
        noResultsDescription: "Versuchen Sie andere Suchbegriffe",
        filterByCategory: "Nach Kategorie filtern",
        allCategories: "Alle Kategorien",
        showingResults: "{count} von {total} Ressourcen werden angezeigt",
        clearFilters: "Filter löschen"
      },
      loadMore: "Mehr laden",
      showLess: "Weniger anzeigen",
      article: {
        readMore: "Artikel Lesen",
        read: "Artikel Lesen"
      },
      videos: {
        comingSoon: "Video-Inhalte Kommen Bald",
        inProgress: "Unser Team arbeitet an der Erstellung von Bildungsvideos.",
        video1: {
          title: "Was ist Inflation?",
          description: "Ökonomen sprechen ständig über Inflation und neigen dazu zu sagen, dass es etwas sehr Schlechtes ist. Aber warum genau, woher kommt es und was kann man tun, um es zu kontrollieren?",
          category: "economy",
          duration: "8:00"
        }
      },
      article1: {
        title: "Die Macht des Zinseszinses",
        description: "Erfahren Sie, wie Zinseszins Ihr Vermögen durch konsequente Investitionen exponentiell wachsen lassen kann."
      },
      article2: {
        title: "Ruhestandsplanungs-Leitfaden",
        description: "Wesentliche Strategien für die Planung Ihres Ruhestands und die Sicherstellung finanzieller Sicherheit in Ihren goldenen Jahren."
      },
      article3: {
        title: "Steueroptimierungsstrategien",
        description: "Fortgeschrittene Techniken zur Minimierung Ihrer Steuerlast und Maximierung Ihrer Anlagerenditen."
      },
      article4: {
        title: "Aufbau eines Notfallfonds",
        description: "Lernen Sie, wie Sie einen Notfallfonds aufbauen und pflegen, um sich vor finanzieller Unsicherheit zu schützen."
      },
      article5: {
        title: "Risiko vs. Rendite verstehen",
        description: "Erkunden Sie die Beziehung zwischen Anlagerisiko und potenziellen Renditen, um fundierte Entscheidungen zu treffen."
      },
      article6: {
        title: "Häufige Anlagefehler und Wie Man Sie Vermeidet",
        description: "Entdecken Sie die häufigsten Anlagefehler und lernen Sie Strategien, um kostspielige Fehler zu vermeiden."
      },
      article7: {
        title: "Mieten vs. Kaufen: Vor- und Nachteile Je Nach Ihrer Situation",
        description: "Treffen Sie die richtige Wohnentscheidung für Ihre finanzielle Zukunft, indem Sie die Vor- und Nachteile jeder Option verstehen."
      },
      article8: {
        title: "Was ist Inflation und wie sie Sie betrifft",
        description: "Die wirtschaftliche Kraft verstehen, die Ihre Kaufkraft und finanziellen Entscheidungen beeinflusst."
      },
      article9: {
        title: "Kryptowährungen: Trend oder Langfristige Investition?",
        description: "Eine ausgewogene Analyse digitaler Währungen als Investitionsmöglichkeit, die Risiken und Potenzial abdeckt."
      },
      article10: {
        title: "Monatliche Spar-Herausforderungen zur Verbesserung Ihrer persönlichen Finanzen",
        description: "Transformieren Sie Ihre Finanzgewohnheiten mit ansprechenden monatlichen Herausforderungen, die darauf ausgelegt sind, Ihre Ersparnisse zu steigern und dauerhafte Geld-Management-Fähigkeiten aufzubauen."
      },
      article11: {
        title: "Wie man Impulskäufe vermeidet",
        description: "Lernen Sie praktische Strategien zur Kontrolle von Ausgabendrängen und bewussteren Finanzentscheidungen für eine gesündere finanzielle Zukunft."
      },
      article12: {
        title: "Wie Sie Ihre Hypothek 2025 Neu Verhandeln",
        description: "Vollständiger Leitfaden mit praktischen Schritten zur Neuverhandlung Ihrer Hypothek und Einsparungen bei Ihren monatlichen Zahlungen."
      },
      article13: {
        title: "Jetzt Kaufen Später Zahlen (BNPL): Budget Auswirkungen und Intelligente Nutzung",
        description: "Erfahren Sie, wie BNPL-Dienste Ihr Budget beeinflussen, ihre Risiken und Vorteile und wie Sie sie verantwortungsvoll für bessere finanzielle Gesundheit nutzen."
      },
      article14: {
        title: "KI zur Optimierung Ihrer persönlichen Finanzen nutzen: Apps, Risiken und reale Fälle",
        description: "Entdecken Sie, wie künstliche Intelligenz die persönliche Geldverwaltung revolutioniert und welche Tools Ihre finanzielle Situation transformieren können."
      },
      article15: {
        title: "Praktischer Steuerführer für Kryptowährungen: Korrekt Deklarieren und Strafen Vermeiden",
        description: "Alles was Sie über Steuerpflichten mit Kryptowährungen wissen müssen, um Steuerbehörden zu erfüllen."
      },
      article16: {
        title: "Investieren mit 100 €: 10 echte Strategien, um heute zu beginnen",
        description: "Entdecken Sie, wie Sie Ihren Weg zur finanziellen Freiheit mit einer kleinen, aber intelligenten Anfangsinvestition beginnen."
      },
      article17: {
        title: "ETFs und Indexfonds: Das praktische Rezept für ein krisenresistentes Portfolio",
        description: "Bauen Sie eine solide und diversifizierte Anlagestrategie auf, die den Turbulenzen der globalen Finanzmärkte standhält."
      },
      article18: {
        title: "Schützen Sie Ihr Geld vor digitalen Betrug: Vishing, Smishing, Deepfakes und was zu tun ist",
        description: "Vollständiger Leitfaden zur Identifizierung und zum Schutz vor den gefährlichsten digitalen Finanzbedrohungen."
      },
      article19: {
        title: "Finanzen für Selbstständige: Budgetplanung bei schwankendem Einkommen und Altersvorsorge",
        description: "Bewährte Strategien für finanzielle Stabilität als Selbstständiger. Von intelligenter Budgetplanung bis zur optimalen Altersvorsorge."
      },
      article20: {
        title: "Nachhaltige Investition ohne Fallen: Wie man Greenwashing in ESG-Fonds erkennt",
        description: "Lernen Sie, wirklich nachhaltige Fonds zu identifizieren und vermeiden Sie es, auf irreführende Marketingpraktiken in der ESG-Investmentwelt hereinzufallen."
      },
      article21: {
        title: "Sparen gegen Inflation: Kurz- und mittelfristige Taktiken, die wirklich funktionieren",
        description: "Bewährte Strategien zum Schutz und Wachstum Ihrer Ersparnisse in inflationären Umgebungen durch praktische, risikokontrollierte Ansätze."
      },
      article22: {
        title: "Verhandeln Sie Ihr Gehalt besser: Argumente, Struktur und Beispiele zur Einkommenssteigerung",
        description: "Entdecken Sie die effektivsten Strategien, Techniken und Argumente, um die Gehaltserhöhung zu erhalten, die Sie verdienen."
      },
      article23: {
        title: "Besteuerung für digitale Nomaden und Fernarbeiter: Was Sie beim Umzug wissen müssen",
        description: "Vollständiger Leitfaden zu Steuerpflichten, Steuerresidenz und Steueroptimierung für Fachkräfte, die international remote arbeiten."
      },
      article24: {
        title: "Finanzielle Unabhängigkeit: Ein realistischer Plan (Keine Fantasien)",
        description: "Praktische und realistische Strategien für finanzielle Unabhängigkeit ohne leere Versprechen oder unmögliche Systeme."
      },
      article25: {
        title: "Robo-Berater vs Menschliche Berater: Wie man basierend auf Kosten und Profil wählt",
        description: "Vollständiger Vergleich zwischen automatisierten und menschlichen Finanzberatungsdiensten. Lernen Sie, die beste Option entsprechend Ihrem Budget, Bedürfnissen und Anlegerprofil zu wählen."
      },
      article26: {
        title: "Tipps zur Reduzierung Ihrer Strom-, Gas- und Internetrechnungen",
        description: "Praktische und effektive Strategien zur erheblichen Reduzierung Ihrer Haushalts-Nebenkosten. Entdecken Sie bewährte Methoden, um 15-40% bei Ihren monatlichen Rechnungen zu sparen."
      },
      article27: {
        title: "Einfacher Leitfaden zum Verständnis der Einkommensteuer und weniger Steuern zahlen",
        description: "Vollständiger Leitfaden zur Optimierung der Einkommensteuer. Lernen Sie legale Strategien, Abzüge und praktische Tipps zur Reduzierung Ihrer Steuerlast und Maximierung Ihrer Ersparnisse."
      },
      article28: {
        title: "Wie man mit wenig Geld in Aktien investiert",
        description: "Vollständiger Leitfaden zum Investieren in Aktien mit kleinen Beträgen. Lernen Sie Strategien, vermeiden Sie Fehler und bauen Sie Schritt für Schritt Vermögen mit minimalem Kapital auf."
      },
      article29: {
        title: "Planen Sie Ihre Finanzen vor der Familiengründung",
        description: "Wesentlicher Leitfaden zur Finanzplanung für Paare, die Kinder planen. Lernen Sie über Budgetierung, Sparstrategien und langfristige finanzielle Vorbereitung für Familienwachstum."
      },
      article30: {
        title: "Wie man mit einem niedrigen Gehalt Geld spart",
        description: "Praktische Strategien für eine solide finanzielle Zukunft, unabhängig von der Höhe Ihres Einkommens. Lernen Sie realistische und nachhaltige Methoden zum Geldsparen mit einem knappen Budget."
      },
      article31: {
        title: "Warum 90% der Trader Geld verlieren",
        description: "Entdecken Sie die wahren Gründe für das Scheitern beim Trading und lernen Sie, die häufigsten Fehler zu vermeiden, die Kapital zerstören. Ein realistischer Leitfaden ohne Fantasien."
      },
      article32: {
        title: "Die wahren Kosten, niemals zu investieren",
        description: "Entdecken Sie den unsichtbaren Preis, den Sie jeden Tag zahlen, indem Sie Ihr Geld untätig lassen, und wie es still Ihre finanzielle Zukunft beeinflusst."
      },
      article33: {
        title: "Unsichtbare Ausgaben, die Sie 3.000€ pro Jahr kosten",
        description: "Entdecken Sie die kleinen versteckten Ausgaben, die Ihr Bankkonto belasten, ohne dass Sie es bemerken, und wie Sie dieses Geld zurückgewinnen können."
      },
      article34: {
        title: "KI bei Investitionen: Wie Algorithmen die Art zu Investieren Verändern",
        description: "Erforschen Sie, wie künstliche Intelligenz und maschinelles Lernen Investitionsstrategien mit automatisierter Analyse und intelligenteren Entscheidungen transformieren."
      },
      article35: {
        title: "Lifestyle-Inflation: Ihr Schlimmster Finanzieller Feind",
        description: "Entdecken Sie, wie schrittweise Erhöhungen Ihres Lebensstils Ihr Vermögen still sabotieren können und lernen Sie bewährte Strategien, um dagegen anzukämpfen."
      },
      article36: {
        title: "Ihre Finanzen vor der Elternschaft vorbereiten: Vollständiger Leitfaden",
        description: "Wesentlicher Leitfaden zur Vorbereitung Ihrer Finanzen vor der Elternschaft. Lernen Sie, eine solide finanzielle Grundlage aufzubauen, Schulden zu verwalten und Ihre Familienzukunft mit praktischen Strategien zu planen."
      },
      article37: {
        title: "DCA vs. Gesamtbetrag Investieren: Was die Daten Sagen",
        description: "Entdecken Sie die intelligenteste Investitionsstrategie basierend auf historischen Beweisen. Vollständige Analyse von Dollar Cost Averaging vs Lump Sum mit echten Daten, psychologischen Faktoren und Leitfaden für Ihre Entscheidung."
      },
      article38: {
        title: "Wie viel brauchen Sie wirklich für den Ruhestand (und wie Sie es erreichen)",
        description: "Ein vollständiger Leitfaden zur Berechnung Ihrer finanziellen Freiheitszahl und zur Erstellung eines realistischen Plans, um sie zu erreichen."
      },
      article39: {
        title: "Finanzbildung für Paare: Wie man Geld in einer Beziehung verwaltet",
        description: "Lernen Sie, eine solide finanzielle Beziehung mit Ihrem Partner aufzubauen. Praktische Strategien für Kommunikation, gemeinsame Budgets und geteilte finanzielle Ziele."
      },
      article40: {
        title: "Ihr erstes Gehalt: Wie man es klug investiert",
        description: "Entdecken Sie wesentliche Strategien, um Ihr erstes Gehalt intelligent zu verwalten und von Beginn Ihrer beruflichen Karriere an eine solide finanzielle Grundlage aufzubauen."
      },
      article41: {
        title: "Automatisieren Sie Ihre Finanzen an einem Nachmittag",
        description: "Lernen Sie, wie Sie ein automatisiertes Finanzsystem einrichten, das rund um die Uhr für Sie arbeitet und Ihnen ermöglicht, ohne täglichen Aufwand bessere Entscheidungen zu treffen."
      },
      article42: {
        title: "Die 1%-Regel, die Ihre Finanzen Transformiert",
        description: "Entdecken Sie, wie kleine tägliche Verbesserungen von nur 1% Ihre finanzielle Situation durch die Kraft zusammengesetzter Gewohnheiten und marginaler Gewinne radikal verändern können."
      },
      article43: {
        title: "Die Verborgene Kraft der Dividenden-Reinvestition",
        description: "Entdecken Sie, wie die Reinvestition von Dividenden Ihr Vermögenswachstum durch zusammengesetzte Renditen und strategischen Portfolioaufbau dramatisch beschleunigen kann."
      },
      article44: {
        title: "Gehaltsverhandlung ist 100.000€ wert",
        description: "Entdecken Sie, wie eine einzige Gehaltsverhandlung einen sechsstelligen Unterschied über Ihre Karriere hinweg ausmachen kann. Die rentabelste finanzielle Entscheidung Ihres Berufslebens."
      },
      article45: {
        title: "Die Angst vor dem Investieren Kostet Sie Teuer",
        description: "Entdecken Sie die wahren Kosten der Investitionsangst und lernen Sie praktische Strategien, um sie mit Vertrauen und schrittweisem Handeln zu überwinden."
      },
      article46: {
        title: "Bevor Sie Ihren Job Kündigen, Tun Sie Dies",
        description: "Die kritischen Entscheidungen, die Sie vor Ihrer Kündigung treffen müssen, um Ihre finanzielle und berufliche Zukunft zu schützen."
      }
    },
    ...dcaVsLumpSumArticleTranslations.de,
    ...howMuchToRetireArticleTranslations.de,
    ...salaryNegotiationWorthArticleTranslations.de
  },
  fr: {
    resources: {
      title: "Ressources Financières",
      subtitle: "Contenu éducatif pour vous aider à prendre de meilleures décisions financières.",
      tabs: {
        articles: "Articles",
        videos: "Vidéos",
        calculators: "Calculatrices"
      },
      categories: {
        investment: "Investissement",
        retirement: "Retraite",
        taxPlanning: "Planification Fiscale",
        budgeting: "Budget et Épargne",
        mortgages: "Hypothèques et Immobilier",
        debt: "Gestion des Dettes",
        technology: "Technologie Financière",
        security: "Sécurité Financière",
        economy: "Économie",
        career: "Carrière"
      },
      search: {
        placeholder: "Rechercher des ressources...",
        noResults: "Aucun résultat trouvé",
        noResultsDescription: "Essayez d'autres termes de recherche",
        filterByCategory: "Filtrer par catégorie",
        allCategories: "Toutes les catégories",
        showingResults: "Affichage de {count} sur {total} ressources",
        clearFilters: "Effacer les filtres"
      },
      loadMore: "Voir plus",
      showLess: "Voir moins",
      article: {
        readMore: "Lire l'Article",
        read: "Lire l'Article"
      },
      videos: {
        comingSoon: "Contenu Vidéo Bientôt Disponible",
        inProgress: "Notre équipe travaille sur la création de vidéos éducatives.",
        video1: {
          title: "Qu'est-ce que l'inflation ?",
          description: "Les économistes parlent constamment d'inflation et ont tendance à suggérer que c'est quelque chose de très mauvais. Mais pourquoi exactement, d'où vient-elle et que peut-on faire pour la contrôler ?",
          category: "economy",
          duration: "8:00"
        }
      },
      article1: {
        title: "Le Pouvoir des Intérêts Composés",
        description: "Apprenez comment les intérêts composés peuvent faire croître exponentiellement votre richesse avec des investissements constants."
      },
      article2: {
        title: "Guide de Planification de Retraite",
        description: "Stratégies essentielles pour planifier votre retraite et assurer la sécurité financière dans vos années dorées."
      },
      article3: {
        title: "Stratégies d'Optimisation Fiscale",
        description: "Techniques avancées pour minimiser votre charge fiscale et maximiser vos retours d'investissement."
      },
      article4: {
        title: "Construire un Fonds d'Urgence",
        description: "Apprenez comment construire et maintenir un fonds d'urgence pour vous protéger de l'incertitude financière."
      },
      article5: {
        title: "Comprendre Risque vs Rendement",
        description: "Apprenez la relation fondamentale entre le risque d'investissement et les rendements potentiels pour prendre des décisions éclairées."
      },
      article6: {
        title: "Erreurs d'Investissement Courantes et Comment les Éviter",
        description: "Découvrez les pièges d'investissement les plus courants et apprenez des stratégies pour éviter les erreurs coûteuses."
      },
      article7: {
        title: "Louer vs Acheter : Avantages et Inconvénients Selon Votre Situation",
        description: "Prenez la bonne décision de logement pour votre avenir financier en comprenant les avantages et inconvénients de chaque option."
      },
      article8: {
        title: "Qu'est-ce que l'inflation et comment elle vous affecte",
        description: "Comprendre la force économique qui impacte votre pouvoir d'achat et vos décisions financières."
      },
      article9: {
        title: "Cryptomonnaies : Tendance ou Investissement à Long Terme ?",
        description: "Une analyse équilibrée des monnaies numériques comme opportunité d'investissement, couvrant les risques et le potentiel."
      },
      article10: {
        title: "Défis d'Épargne Mensuels pour Améliorer vos Finances Personnelles",
        description: "Transformez vos habitudes financières avec ces défis mensuels engageants conçus pour augmenter votre épargne et développer des compétences durables de gestion de l'argent."
      },
      article11: {
        title: "Comment Éviter les Achats Impulsifs",
        description: "Apprenez des stratégies pratiques pour contrôler les envies de dépenser et prendre des décisions financières plus réfléchies pour un avenir financier plus sain."
      },
      article12: {
        title: "Comment Renégocier Votre Hypothèque en 2025",
        description: "Guide complet avec des étapes pratiques pour renégocier votre hypothèque et économiser sur vos paiements mensuels."
      },
      article13: {
        title: "Acheter Maintenant Payer Plus Tard (BNPL): Impact Budget et Usage Intelligent",
        description: "Apprenez comment les services BNPL affectent votre budget, leurs risques et avantages, et comment les utiliser de manière responsable pour une meilleure santé financière."
      },
      article14: {
        title: "Utiliser l'IA pour optimiser vos finances personnelles: apps, risques et cas réels",
        description: "Découvrez comment l'intelligence artificielle révolutionne la gestion de l'argent personnel et quels outils peuvent transformer votre situation financière."
      },
      article15: {
        title: "Guide Fiscal Pratique pour les Cryptomonnaies: Déclarez Correctement et Évitez les Sanctions",
        description: "Tout ce que vous devez savoir sur les obligations fiscales avec les cryptomonnaies pour vous conformer aux autorités fiscales."
      },
      article16: {
        title: "Investir avec 100 € : 10 stratégies réelles pour commencer aujourd'hui",
        description: "Découvrez comment commencer votre chemin vers la liberté financière avec un petit investissement initial mais intelligent."
      },
      article17: {
        title: "ETF et Fonds Indiciels : La Recette Pratique pour un Portefeuille Résistant aux Crises",
        description: "Construisez une stratégie d'investissement solide et diversifiée qui résiste aux turbulences des marchés financiers mondiaux."
      },
      article18: {
        title: "Protégez votre argent des arnaques numériques : vishing, smishing, deepfakes et que faire",
        description: "Guide complet pour identifier et vous protéger des menaces financières numériques les plus dangereuses."
      },
      article19: {
        title: "Finances pour indépendants : comment budgétiser avec des revenus variables et préparer votre retraite",
        description: "Stratégies éprouvées pour la stabilité financière en tant qu'indépendant. De la budgétisation intelligente à la retraite optimale."
      },
      article20: {
        title: "Investissement Durable sans Pièges : Comment Détecter le Greenwashing dans les Fonds ESG",
        description: "Apprenez à identifier les fonds véritablement durables et évitez de tomber dans les pratiques de marketing trompeuses dans le monde de l'investissement ESG."
      },
      article21: {
        title: "Épargner contre l'inflation : Tactiques à court et moyen terme qui fonctionnent vraiment",
        description: "Stratégies éprouvées pour protéger et faire croître vos économies dans des environnements inflationnistes grâce à des approches pratiques et gérées en termes de risque."
      },
      article22: {
        title: "Négociez mieux votre salaire : arguments, structure et exemples pour augmenter vos revenus",
        description: "Découvrez les stratégies, techniques et arguments les plus efficaces pour obtenir l'augmentation salariale que vous méritez."
      },
      article23: {
        title: "Fiscalité pour nomades numériques et télétravailleurs : ce qu'il faut savoir en déménageant",
        description: "Guide complet sur les obligations fiscales, résidence fiscale et optimisation fiscale pour les professionnels travaillant à distance internationalement."
      },
      article24: {
        title: "Indépendance Financière: Un Plan Réaliste (Sans Fantasmes)",
        description: "Stratégies pratiques et réalistes pour atteindre l'indépendance financière sans promesses vides ou systèmes impossibles."
      },
      article25: {
        title: "Robo-conseillers vs Conseillers Humains: Comment choisir selon les coûts et le profil",
        description: "Comparaison complète entre services de conseil financier automatisé et humain. Apprenez à choisir la meilleure option selon votre budget, besoins et profil d'investisseur."
      },
      article26: {
        title: "Astuces pour Payer Moins sur vos Factures d'Électricité, de Gaz et d'Internet",
        description: "Stratégies pratiques et efficaces pour réduire significativement vos dépenses en services domestiques de base. Découvrez des méthodes éprouvées pour économiser 15-40% sur vos factures mensuelles."
      },
      article27: {
        title: "Guide Simple pour Comprendre l'Impôt sur le Revenu et Payer Moins d'Impôts",
        description: "Guide complet pour l'optimisation de l'impôt sur le revenu. Apprenez les stratégies légales, déductions et conseils pratiques pour réduire votre charge fiscale et maximiser vos économies."
      },
      article28: {
        title: "Comment commencer à investir en bourse avec peu d'argent",
        description: "Guide complet pour commencer à investir en bourse avec de petites sommes. Apprenez les stratégies, évitez les erreurs et construisez la richesse étape par étape avec un capital minimum."
      },
      article29: {
        title: "Planifiez vos finances avant d'avoir des enfants",
        description: "Guide essentiel de planification financière pour les couples qui planifient d'avoir des enfants. Apprenez la budgétisation, les stratégies d'épargne et la préparation financière à long terme."
      },
      article30: {
        title: "Comment économiser de l'argent avec un salaire bas",
        description: "Stratégies pratiques pour construire un avenir financier solide quelle que soit la taille de vos revenus. Apprenez des méthodes réalistes et durables pour économiser de l'argent avec un budget serré."
      },
      article31: {
        title: "Pourquoi 90% des traders perdent de l'argent",
        description: "Découvrez les véritables raisons de l'échec du trading et apprenez à éviter les erreurs les plus courantes qui détruisent le capital. Un guide réaliste sans fantasmes."
      },
      article32: {
        title: "Le Coût Réel de Ne Jamais Investir",
        description: "Découvrez le prix invisible que vous payez chaque jour en gardant votre argent inactif et comment cela affecte silencieusement votre avenir financier."
      },
      article33: {
        title: "Dépenses Invisibles qui Vous Coûtent 3 000€ par An",
        description: "Découvrez les petites dépenses cachées qui vident votre compte bancaire sans que vous vous en rendiez compte et comment récupérer cet argent."
      },
      article34: {
        title: "IA dans les Investissements : Comment les Algorithmes Changent la Façon d'Investir",
        description: "Explorez comment l'intelligence artificielle et l'apprentissage automatique transforment les stratégies d'investissement avec une analyse automatisée et des décisions plus intelligentes."
      },
      article35: {
        title: "Inflation du Style de Vie : Votre Pire Ennemi Financier",
        description: "Découvrez comment les augmentations progressives de votre style de vie peuvent silencieusement saboter votre richesse et apprenez des stratégies éprouvées pour la combattre."
      },
      article36: {
        title: "Préparez vos Finances avant de Devenir Parent: Guide Complet",
        description: "Guide complet pour préparer vos finances avant de devenir parent. Apprenez à construire une base solide, réduire les dettes et planifier les changements de revenus."
      },
      article37: {
        title: "DCA vs. Investir en une Seule Fois: Ce Que Disent les Données",
        description: "Analyse approfondie basée sur les données de deux stratégies d'investissement : investissement progressif (DCA) vs. investissement en une seule fois (Lump Sum). Découvrez quelle stratégie convient le mieux à votre situation."
      },
      article38: {
        title: "Combien vous faut-il vraiment pour prendre votre retraite (et comment y arriver)",
        description: "Un guide complet pour calculer votre chiffre de liberté financière et créer un plan réaliste pour l'atteindre."
      },
      article39: {
        title: "Éducation Financière pour les Couples : Comment Gérer l'Argent en Relation",
        description: "Apprenez à construire une relation financière solide avec votre partenaire. Stratégies pratiques pour la communication, les budgets communs et les objectifs financiers partagés."
      },
      article40: {
        title: "Votre premier salaire : comment l'investir judicieusement",
        description: "Découvrez les stratégies essentielles pour gérer intelligemment votre premier salaire et construire une base financière solide dès le début de votre carrière professionnelle."
      },
      article41: {
        title: "Automatisez vos finances en une après-midi",
        description: "Apprenez à mettre en place un système financier automatisé qui travaille pour vous 24h/24, vous permettant de prendre de meilleures décisions sans effort quotidien."
      },
      article42: {
        title: "La Règle du 1% qui Transformera vos Finances",
        description: "Découvrez comment de petites améliorations quotidiennes de seulement 1% peuvent transformer radicalement votre situation financière grâce au pouvoir des habitudes composées et des gains marginaux."
      },
      article43: {
        title: "Le Pouvoir Caché du Réinvestissement des Dividendes",
        description: "Découvrez comment le réinvestissement des dividendes peut accélérer considérablement la croissance de votre patrimoine grâce aux rendements composés et à la construction stratégique de portefeuille."
      },
      article44: {
        title: "Négocier votre salaire vaut 100.000€",
        description: "Découvrez comment une seule négociation salariale peut représenter une différence à six chiffres au cours de votre carrière. La décision financière la plus rentable de votre vie professionnelle."
      },
      article45: {
        title: "La Peur d'Investir Vous Coûte Cher",
        description: "Découvrez le véritable coût de la peur d'investir et apprenez des stratégies pratiques pour la surmonter avec confiance et action progressive."
      },
      article46: {
        title: "Avant de Quitter Votre Emploi, Faites Ceci",
        description: "Les décisions critiques que vous devez prendre avant de démissionner pour protéger votre avenir financier et professionnel."
      }
    },
    ...dcaVsLumpSumArticleTranslations.fr,
    ...howMuchToRetireArticleTranslations.fr,
    ...salaryNegotiationWorthArticleTranslations.fr
  },
  hi: {
    resources: {
      title: "वित्तीय संसाधन",
      subtitle: "बेहतर वित्तीय निर्णय लेने में आपकी मदद करने के लिए शैक्षिक सामग्री।",
      tabs: {
        articles: "लेख",
        videos: "वीडियो",
        calculators: "कैलकुलेटर"
      },
      categories: {
        investment: "निवेश",
        retirement: "सेवानिवृत्ति",
        taxPlanning: "कर योजना",
        budgeting: "बजट और बचत",
        mortgages: "बंधक और रियल एस्टेट",
        debt: "ऋण प्रबंधन",
        technology: "वित्तीय प्रौद्योगिकी",
        security: "वित्तीय सुरक्षा",
        economy: "अर्थव्यवस्था",
        career: "करियर"
      },
      search: {
        placeholder: "संसाधन खोजें...",
        noResults: "कोई परिणाम नहीं मिला",
        noResultsDescription: "अन्य खोज शब्दों का प्रयास करें",
        filterByCategory: "श्रेणी के अनुसार फ़िल्टर करें",
        allCategories: "सभी श्रेणियां",
        showingResults: "{total} में से {count} संसाधन दिखाए जा रहे हैं",
        clearFilters: "फ़िल्टर साफ़ करें"
      },
      loadMore: "और देखें",
      showLess: "कम देखें",
      article: {
        readMore: "लेख पढ़ें",
        read: "लेख पढ़ें"
      },
      videos: {
        comingSoon: "वीडियो सामग्री जल्द आ रही है",
        inProgress: "हमारी टीम शैक्षिक वीडियो बनाने पर काम कर रही है।",
        video1: {
          title: "महंगाई क्या है?",
          description: "अर्थशास्त्री लगातार महंगाई के बारे में बात करते हैं और यह सुझाते हैं कि यह कुछ बहुत बुरा है। लेकिन वास्तव में क्यों, यह कहां से आती है और इसे नियंत्रित करने के लिए क्या किया जा सकता है?",
          category: "economy",
          duration: "8:00"
        }
      },
      article1: {
        title: "चक्रवृद्धि ब्याज की शक्ति",
        description: "जानें कि कैसे चक्रवृद्धि ब्याज निरंतर निवेश के साथ आपकी संपत्ति को तेजी से बढ़ा सकता है।"
      },
      article2: {
        title: "सेवानिवृत्ति योजना गाइड",
        description: "अपनी सेवानिवृत्ति की योजना बनाने और अपने सुनहरे वर्षों में वित्तीय सुरक्षा सुनिश्चित करने की आवश्यक रणनीतियां।"
      },
      article3: {
        title: "कर अनुकूलन रणनीतियां",
        description: "आपके कर बोझ को कम करने और आपके निवेश रिटर्न को अधिकतम करने की उन्नत तकनीकें।"
      },
      article4: {
        title: "आपातकालीन फंड का निर्माण",
        description: "वित्तीय अनिश्चितता से खुद को बचाने के लिए आपातकालीन फंड बनाना और बनाए रखना सीखें।"
      },
      article5: {
        title: "जोखिम बनाम रिटर्न को समझना",
        description: "सूचित निर्णय लेने के लिए निवेश जोखिम और संभावित रिटर्न के बीच मौलिक संबंध के बारे में जानें।"
      },
      article6: {
        title: "सामान्य निवेश गलतियाँ और उनसे कैसे बचें",
        description: "सबसे सामान्य निवेश नुकसान खोजें और महंगी गलतियों से बचने की रणनीतियाँ सीखें।"
      },
      article7: {
        title: "किराया बनाम खरीदना: आपकी स्थिति के आधार पर फायदे और नुकसान",
        description: "प्रत्येक विकल्प के फायदे और नुकसान को समझकर अपने वित्तीय भविष्य के लिए सही आवास निर्णय लें।"
      },
      article8: {
        title: "मुद्रास्फीति क्या है और यह आपको कैसे प्रभावित करती है",
        description: "उस आर्थिक शक्ति को समझना जो आपकी क्रय शक्ति और वित्तीय निर्णयों को प्रभावित करती है।"
      },
      article9: {
        title: "क्रिप्टोकरेंसी: ट्रेंड या लंबी अवधि का निवेश?",
        description: "डिजिटल मुद्राओं का एक संतुलित विश्लेषण निवेश के अवसर के रूप में, जोखिम और संभावनाओं को कवर करते हुए।"
      },
      article10: {
        title: "आपके व्यक्तिगत वित्त में सुधार के लिए मासिक बचत चुनौतियां",
        description: "इन आकर्षक मासिक चुनौतियों के साथ अपनी वित्तीय आदतों को बदलें जो आपकी बचत बढ़ाने और स्थायी धन प्रबंधन कौशल बनाने के लिए डिज़ाइन की गई हैं।"
      },
      article11: {
        title: "आवेगशील खरीदारी से कैसे बचें",
        description: "खर्च की इच्छाओं को नियंत्रित करने और एक स्वस्थ वित्तीय भविष्य के लिए अधिक सचेत वित्तीय निर्णय लेने के लिए व्यावहारिक रणनीतियां सीखें।"
      },
      article12: {
        title: "2025 में अपने होम लोन को कैसे फिर से बातचीत करें",
        description: "अपने होम लोन की पुनर्वार्ता करने और अपनी मासिक भुगतानों पर बचत करने के लिए व्यावहारिक चरणों के साथ पूर्ण गाइड।"
      },
      article13: {
        title: "अभी खरीदें बाद में भुगतान (BNPL): बजट प्रभाव और स्मार्ट उपयोग",
        description: "जानें कि BNPL सेवाएं आपके बजट को कैसे प्रभावित करती हैं, उनके जोखिम और लाभ, और बेहतर वित्तीय स्वास्थ्य के लिए उन्हें जिम्मेदारी से कैसे उपयोग करें।"
      },
      article14: {
        title: "अपने व्यक्तिगत वित्त को अनुकूलित करने के लिए AI का उपयोग करें: ऐप्स, जोखिम और वास्तविक मामले",
        description: "जानें कि कैसे कृत्रिम बुद्धिमत्ता व्यक्तिगत धन प्रबंधन में क्रांति ला रही है और कौन से उपकरण आपकी वित्तीय स्थिति को बदल सकते हैं।"
      },
      article15: {
        title: "क्रिप्टोकरेंसी के लिए व्यावहारिक कर गाइड: सही घोषणा करें और दंड से बचें",
        description: "कर अधिकारियों के साथ अनुपालन के लिए क्रिप्टोकरेंसी के साथ कर दायित्वों के बारे में जानने योग्य सब कुछ।"
      },
      article16: {
        title: "100 € के साथ निवेश: आज ही शुरू करने के लिए 10 वास्तविक रणनीतियां",
        description: "छोटे लेकिन स्मार्ट प्रारंभिक निवेश के साथ वित्तीय स्वतंत्रता की दिशा में अपनी यात्रा शुरू करना जानें।"
      },
      article17: {
        title: "ETF और इंडेक्स फंड: संकट-प्रतिरोधी पोर्टफोलियो के लिए व्यावहारिक रेसिपी",
        description: "एक मजबूत और विविधीकृत निवेश रणनीति बनाएं जो वैश्विक वित्तीय बाजार की अशांति का सामना कर सके।"
      },
      article18: {
        title: "डिजिटल घोटालों से अपने पैसे को सुरक्षित रखें: विशिंग, स्मिशिंग, डीपफेक्स और क्या करें",
        description: "सबसे खतरनाक डिजिटल वित्तीय खतरों की पहचान और सुरक्षा के लिए पूर्ण गाइड।"
      },
      article19: {
        title: "स्वतंत्र कामगारों के लिए वित्त: परिवर्तनशील आय के साथ बजट बनाना और सेवानिवृत्ति की तैयारी",
        description: "स्वतंत्र कामगार के रूप में वित्तीय स्थिरता के लिए सिद्ध रणनीतियां। स्मार्ट बजटिंग से लेकर इष्टतम सेवानिवृत्ति तक।"
      },
      article20: {
        title: "जाल के बिना टिकाऊ निवेश: ESG फंड में ग्रीनवाशिंग का पता कैसे लगाएं",
        description: "वास्तव में टिकाऊ फंड की पहचान करना सीखें और ESG निवेश की दुनिया में भ्रामक मार्केटिंग प्रथाओं में फंसने से बचें।"
      },
      article21: {
        title: "मुद्रास्फीति के खिलाफ बचत: छोटी और मध्यम अवधि की रणनीति जो वास्तव में काम करती है",
        description: "व्यावहारिक, जोखिम-प्रबंधित दृष्टिकोणों के माध्यम से मुद्रास्फीति के माहौल में अपनी बचत की सुरक्षा और वृद्धि के लिए सिद्ध रणनीतियां।"
      },
      article22: {
        title: "अपनी सैलरी बेहतर तरीके से नेगोसिएट करें: आय बढ़ाने के लिए तर्क, संरचना और उदाहरण",
        description: "वेतन वृद्धि पाने के लिए सबसे प्रभावी रणनीतियां, तकनीकें और तर्कों की खोज करें जिसके आप हकदार हैं।"
      },
      article23: {
        title: "डिजिटल नोमैड्स और रिमोट वर्कर्स के लिए कराधान: स्थानांतरण पर जानने योग्य बातें",
        description: "अंतर्राष्ट्रीय स्तर पर रिमोट काम करने वाले पेशेवरों के लिए कर दायित्व, कर निवास और कर अनुकूलन पर पूर्ण गाइड।"
      },
      article24: {
        title: "वित्तीय स्वतंत्रता: एक यथार्थवादी योजना (कोई कल्पनाएं नहीं)",
        description: "खाली वादों या असंभव सिस्टम के बिना वित्तीय स्वतंत्रता प्राप्त करने के लिए व्यावहारिक और यथार्थवादी रणनीतियां।"
      },
      article25: {
        title: "रोबो-सलाहकार बनाम मानव सलाहकार: लागत और प्रोफाइल के आधार पर कैसे चुनें",
        description: "स्वचालित और मानव वित्तीय सलाहकार सेवाओं के बीच पूर्ण तुलना। अपने बजट, आवश्यकताओं और निवेशक प्रोफाइल के अनुसार सर्वोत्तम विकल्प चुनना सीखें।"
      },
      article26: {
        title: "बिजली, गैस और इंटरनेट के बिलों में कम भुगतान करने की तरकीबें",
        description: "घरेलू उपयोगिता खर्चों को काफी कम करने के लिए व्यावहारिक और प्रभावी रणनीतियां। अपने मासिक बिलों पर 15-40% बचत के लिए सिद्ध तरीकों की खोज करें।"
      },
      article27: {
        title: "आयकर को समझने और कम कर चुकाने की सरल गाइड",
        description: "आयकर अनुकूलन के लिए पूर्ण गाइड। कानूनी रणनीतियों, कटौती और व्यावहारिक सुझावों को सीखें ताकि आप अपना कर भार कम कर सकें और अपनी बचत को अधिकतम बना सकें।"
      },
      article28: {
        title: "कम पैसे से स्टॉक मार्केट में निवेश कैसे शुरू करें",
        description: "कम राशि से स्टॉक में निवेश शुरू करने के लिए पूर्ण गाइड। रणनीतियां सीखें, गलतियों से बचें और न्यूनतम पूंजी के साथ कदम दर कदम धन बनाएं।"
      },
      article29: {
        title: "बच्चे पैदा करने से पहले अपनी वित्तीय योजना बनाएं",
        description: "बच्चे पैदा करने की योजना बना रहे जोड़ों के लिए आवश्यक वित्तीय नियोजन गाइड। बजटिंग, बचत रणनीतियों और दीर्घकालिक वित्तीय तैयारी के बारे में सीखें।"
      },
      article30: {
        title: "कम वेतन पर पैसे कैसे बचाएं",
        description: "आपकी आय के आकार की परवाह किए बिना एक मजबूत वित्तीय भविष्य बनाने की व्यावहारिक रणनीतियां। तंग बजट के साथ पैसे बचाने के यथार्थवादी और टिकाऊ तरीके सीखें।"
      },
      article31: {
        title: "90% ट्रेडर्स पैसे क्यों खो देते हैं",
        description: "ट्रेडिंग विफलता के पीछे के वास्तविक कारणों को जानें और सबसे आम गलतियों से बचना सीखें जो पूंजी को नष्ट करती हैं। कल्पनाओं के बिना एक यथार्थवादी गाइड।"
      },
      article32: {
        title: "कभी निवेश न करने की वास्तविक लागत",
        description: "अपने पैसे को निष्क्रिय रखकर आप हर दिन जो अदृश्य कीमत चुकाते हैं और यह आपके वित्तीय भविष्य को चुपचाप कैसे प्रभावित कर रहा है, उसे जानें।"
      },
      article33: {
        title: "अदृश्य खर्चे जो आपको प्रति वर्ष 3,000€ खर्च करते हैं",
        description: "उन छोटे छिपे हुए खर्चों को खोजें जो बिना आपकी जानकारी के आपके बैंक खाते को खाली कर रहे हैं और वह पैसा कैसे वापस पाएं।"
      },
      article34: {
        title: "निवेश में एआई: एल्गोरिदम निवेश के तरीके को कैसे बदल रहे हैं",
        description: "जानें कि कैसे कृत्रिम बुद्धिमत्ता और मशीन लर्निंग स्वचालित विश्लेषण और स्मार्ट निर्णय लेने के साथ निवेश रणनीतियों को बदल रहे हैं।"
      },
      article35: {
        title: "लाइफस्टाइल इन्फ्लेशन: आपका सबसे बड़ा वित्तीय दुश्मन",
        description: "जानें कि कैसे आपकी जीवनशैली में क्रमिक वृद्धि चुपचाप आपकी संपत्ति को नुकसान पहुंचा सकती है और इससे लड़ने के लिए सिद्ध रणनीतियां सीखें।"
      },
      article36: {
        title: "माता-पिता बनने से पहले अपने वित्त तैयार करें: पूर्ण मार्गदर्शिका",
        description: "माता-पिता बनने से पहले अपने वित्त तैयार करने के लिए पूर्ण मार्गदर्शिका। एक ठोस आधार बनाना, ऋण कम करना और आय परिवर्तनों की योजना बनाना सीखें।"
      },
      article37: {
        title: "DCA बनाम एकमुश्त निवेश: डेटा क्या कहता है",
        description: "दो निवेश रणनीतियों का गहन डेटा-आधारित विश्लेषण: क्रमिक निवेश (DCA) बनाम एकमुश्त निवेश (Lump Sum)। जानें कि आपकी स्थिति के लिए कौन सी रणनीति सबसे अच्छी है।"
      },
      article38: {
        title: "सेवानिवृत्ति के लिए आपको वास्तव में कितने पैसे चाहिए (और वहां कैसे पहुंचें)",
        description: "अपनी वित्तीय स्वतंत्रता संख्या की गणना करने और इसे प्राप्त करने के लिए एक यथार्थवादी योजना बनाने के लिए एक पूर्ण मार्गदर्शिका।"
      },
      article39: {
        title: "जोड़ों के लिए वित्तीय शिक्षा: रिश्ते में पैसे का प्रबंधन कैसे करें",
        description: "अपने साथी के साथ एक मजबूत वित्तीय संबंध बनाना सीखें। संचार, संयुक्त बजट और साझा वित्तीय लक्ष्यों के लिए व्यावहारिक रणनीतियां।"
      },
      article40: {
        title: "आपका पहला वेतन: इसे समझदारी से कैसे निवेश करें",
        description: "अपने पेशेवर करियर की शुरुआत से ही एक मजबूत वित्तीय आधार बनाने के लिए अपने पहले वेतन को समझदारी से प्रबंधित करने की आवश्यक रणनीतियों की खोज करें।"
      },
      article41: {
        title: "एक दोपहर में अपने वित्त को स्वचालित करें",
        description: "सीखें कि कैसे एक स्वचालित वित्तीय प्रणाली स्थापित करें जो आपके लिए 24/7 काम करती है, जिससे आप दैनिक प्रयास के बिना बेहतर निर्णय ले सकें।"
      },
      article42: {
        title: "1% नियम जो आपके वित्त को बदल देगा",
        description: "जानें कि कैसे केवल 1% के छोटे दैनिक सुधार संयोजित आदतों और सीमांत लाभ की शक्ति के माध्यम से आपकी वित्तीय स्थिति को मूलभूत रूप से बदल सकते हैं।"
      },
      article43: {
        title: "लाभांश पुनर्निवेश की छिपी शक्ति",
        description: "जानें कि कैसे लाभांश पुनर्निवेश संयोजित रिटर्न और रणनीतिक पोर्टफोलियो निर्माण के माध्यम से आपकी संपत्ति वृद्धि को नाटकीय रूप से तेज कर सकता है।"
      },
      article44: {
        title: "आपके वेतन की बातचीत की कीमत 100,000€ है",
        description: "जानें कि कैसे एक वेतन वार्ता आपके करियर में छह अंकों का अंतर बना सकती है। आपके पेशेवर जीवन में सबसे लाभदायक वित्तीय निर्णय।"
      },
      article45: {
        title: "निवेश का डर आपको महंगा पड़ता है",
        description: "निवेश के डर की वास्तविक लागत जानें और इसे आत्मविश्वास और धीरे-धीरे कार्रवाई के साथ पार करने के लिए व्यावहारिक रणनीतियां सीखें।"
      },
      article46: {
        title: "अपनी नौकरी छोड़ने से पहले, यह करें",
        description: "अपने वित्तीय और पेशेवर भविष्य की रक्षा के लिए इस्तीफा देने से पहले आपको जो महत्वपूर्ण निर्णय लेने चाहिए।"
      },
    },
    ...dcaVsLumpSumArticleTranslations.hi,
    ...howMuchToRetireArticleTranslations.hi,
    ...salaryNegotiationWorthArticleTranslations.hi
  }
};

export default resourcesTranslations;